import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/Index'

Vue.use(VueRouter)

const routes = [
  // { path: '/', redirect: '/Index' },
  {
      path: '/',
      name: 'Index',
      component: Index
  },
  // { path: '/Index', component: Index  },
  { path: '/New_Page/test', component: () => import('@/components/New_Page/test') }

  
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
